import { render, staticRenderFns } from "./breadcrumbs.component.vue?vue&type=template&id=075d69f6&scoped=true&"
import script from "./breadcrumbs.component.ts?vue&type=script&lang=ts&"
export * from "./breadcrumbs.component.ts?vue&type=script&lang=ts&"
import style0 from "./breadcrumbs.component.scss?vue&type=style&index=0&id=075d69f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d69f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem})
